(function () {

  'use strict';

  function pxSelectSnmp(SnmpConfigurationService) {
    return {
      restrict: 'EA',
      scope: {
        formData: '=',
        callback: '&'
      },
      templateUrl: 'app/directives/select-snmp/select-snmp.template.html',
      link: function (scope) {
        scope.networkIdAsArray = scope.formData.network ? [scope.formData.network.customProperties.id] : null;
        scope.snmpConfigurationSelectorIsOpen = false;
        scope.selectedSnmpConfiguration = null;
        scope.defaultSnmpConfiguration = null;

        scope.openSnmpConfigurationSelector = function () {
          scope.snmpConfigurationSelectorIsOpen = true;
        };

        scope.onSnmpConfigurationSelected = function (snmpConfiguration) {
          scope.snmpConfigurationSelectorIsOpen = false;
          if (snmpConfiguration && (!scope.selectedSnmpConfiguration || snmpConfiguration.info._links.self.href !== scope.selectedSnmpConfiguration.info._links.self.href)) {
            scope.selectedSnmpConfiguration = snmpConfiguration;
            passSelectionToParent();
          }
        };

        function getDefaultSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.defaultSnmpConfiguration = defaultSnmpConfiguration;
          }).catch(function(error){});
        }

        function passSelectionToParent() {
          scope.callback({
            item: scope.selectedSnmpConfiguration,
            boolean: !!scope.selectedSnmpConfiguration
          });
        }

        (function () {
          getDefaultSnmpConfiguration();
        }());

      }
    };
  }

  pxSelectSnmp.$inject = ['SnmpConfigurationService'];

  angular
    .module('printix-admin')
    .directive('pxSelectSnmp', pxSelectSnmp);

})();
